'use es6';

import PropTypes from 'prop-types';
import { Suspense, PureComponent } from 'react';
import { THREAD_VIEW, THREAD_LIST, KNOWLEDGE_BASE, KNOWLEDGE_BASE_ARTICLE, CATEGORY_VIEW } from 'conversations-visitor-experience-components/visitor-widget/constants/views';
import Views from 'conversations-visitor-experience-components/visitor-widget/proptypes/WidgetViews';
import WidgetPlaceholder from 'conversations-visitor-experience-components/visitor-widget/components/WidgetPlaceholder';
import VisitorWidgetContainer from '../visitor-widget/containers/VisitorWidgetContainer';
import { lazyWithPreload } from '../utils/lazyWithPreload';
import FadeSlideInTransition from '../transition/FadeSlideInTransition';
import { withBrowserSizeContext } from '../containers/withBrowserSizeContext';
import CategoryArticles from '../knowledge-base/components/CategoryArticles';
import KBArticle from '../kb-article/components/KBArticle';
import CloseButton from '../mobile-sdk/components/CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
export class CurrentView extends PureComponent {
  constructor(props) {
    super(props);
    this.ThreadView = lazyWithPreload(() => import( /* webpackChunkName: "CurrentView-ThreadView" */'../components/ThreadView'));
    this.KnowledgeBaseContainer = lazyWithPreload(() => import( /* webpackChunkName: "CurrentView-KnowledgeBaseContainerV2" */'../knowledge-base/components/KnowledgeBaseContainerV2'));
    this.ThreadListContainer = lazyWithPreload(() => import( /* webpackChunkName: "CurrentView-ThreadListContainer" */'../containers/ThreadListContainer'));
  }
  renderView() {
    const {
      currentView
    } = this.props;
    if (!currentView) {
      return null;
    }
    switch (currentView) {
      case THREAD_VIEW:
        return /*#__PURE__*/_jsx(this.ThreadView, {});
      case KNOWLEDGE_BASE:
        return /*#__PURE__*/_jsx(this.KnowledgeBaseContainer, {});
      case THREAD_LIST:
        return /*#__PURE__*/_jsx(this.ThreadListContainer, {});
      case CATEGORY_VIEW:
        return /*#__PURE__*/_jsx(CategoryArticles, {});
      case KNOWLEDGE_BASE_ARTICLE:
        return /*#__PURE__*/_jsx(KBArticle, {});
      default:
        {
          return /*#__PURE__*/_jsx(WidgetPlaceholder, {});
        }
    }
  }
  renderContent() {
    const {
      closeWidget,
      browserWindowHeight,
      browserWindowWidth,
      inline,
      currentView
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      style: {
        height: '100%'
      },
      id: "current-view-component",
      children: /*#__PURE__*/_jsx(VisitorWidgetContainer, {
        browserWindowHeight: browserWindowHeight,
        browserWindowWidth: browserWindowWidth,
        closeWidget: closeWidget,
        inline: inline,
        renderSdkCloseButton: CloseButton,
        view: currentView,
        children: /*#__PURE__*/_jsx(Suspense, {
          fallback: /*#__PURE__*/_jsx(WidgetPlaceholder, {}),
          children: this.renderView()
        })
      })
    }, "widget");
  }
  render() {
    const {
      onOpenAnimationStarted,
      onCloseAnimationStarted,
      onOpenAnimationFinished,
      onCloseAnimationFinished,
      isOpen
    } = this.props;
    return /*#__PURE__*/_jsx(FadeSlideInTransition, {
      duration: 500,
      in: isOpen,
      onEnter: onOpenAnimationStarted,
      onEntered: onOpenAnimationFinished,
      onExit: onCloseAnimationStarted,
      onExited: onCloseAnimationFinished,
      children: this.renderContent()
    });
  }
}
CurrentView.displayName = 'CurrentView';
CurrentView.defaultProps = {
  onAnimationsFinished: () => {},
  onAnimationsStarted: () => {}
};
CurrentView.propTypes = {
  browserWindowHeight: PropTypes.number.isRequired,
  browserWindowWidth: PropTypes.number.isRequired,
  closeWidget: PropTypes.func.isRequired,
  currentView: Views,
  inline: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool,
  onCloseAnimationFinished: PropTypes.func,
  onCloseAnimationStarted: PropTypes.func,
  onOpenAnimationFinished: PropTypes.func,
  onOpenAnimationStarted: PropTypes.func
};
export default withBrowserSizeContext(CurrentView);